import React from 'react'

export const AccountStatement = ({ useFetchInit }) => {
    return (
        <div>AccountStatement</div>
    )
}
